import _ from 'lodash'
import { fmtSize, parseDemandState, parseTime } from '@/filters'
import {
  bizScenario,
  customerTypeList,
  exchangeCreationTypes,
} from '@/common/demand'
import useValueExchangeLabel from '@/utils/useValueExchangeLabel'
import {
  interactiveChannelList,
  nonInteractiveChannelList,
} from '@com/utils/channel'

// // 所有export header的全集
export const headerConfig = {
  id: 'ID',
  name: '需求名称',
  app_names: '产品名称',
  instruction: '需求说明',
  tag_names: '创意标签',
  material_tag_names: '特征标签',
  attachment_size: 'Size',
  difficulty: '需求评级',
  demand_name: '关联需求',
  creation_types: '创意类型',
  platforms: '投放平台',
  adv_name: '广告主',
  channels: '投放渠道/语言',
  channel: '投放渠道/语言',
  key_account: '是否KA',
  priority: '我的优先级',
  status: '状态',
  demander_name: '提需人',
  account_manager_name: 'AM',
  planner_name: '策划师',
  designer_name: '设计师',
  submit_time: '提需日期',
  expect_time: '期望完成日期',
  'estimated-cell': '计划完成日期',
  worktime: '工时消耗',
  deliver_time: '实际完成日期',
  start_date: '开始时间',
  end_date: '结束时间',
  newday: '计划完成日期（新）',
  'creation-cell': '创意名称',
  creation_name: '创意名称',
  tag_ids: '创意标签',
  tags: '创意标签',
  creation_size: 'Dimension',
  impression: 'impression',
  clicks: 'click',
  install: 'install',
  spend: 'Spend',
  cpi: 'CPI',
  ctr: 'CTR',
  cvr: 'CRV',
  ivr: 'IVR',
  roi: 'Roi',
  ecpc: 'eCpc',
  ecpm: 'eCPM',
  developer_name: '研发',
  total_tasks: '关联测试任务',
  order_time: '下单日期',
  similar_demand_ids: '参考需求',
  service_attribution_label: '服务归属',
  service_type_label: '服务类型',
  preview_url: '预览地址',
  project_type: '项目类型',
  biz_scenario: '业务场景',
  bind_project_id: '绑定项目 ID',
}

export const cookContentItem = (row) => {
  const item = {
    ...row,
    attachment_size: fmtSize(row.attachment_size),
    creation_types: exchangeCreationTypes(row.creation_types) || '-',
    channels: ((row) => {
      if (row && row.channel_ids) {
        const channels = row.channel_ids.split(',')
        return channels
          .map((channel) => {
            return (
              useValueExchangeLabel(
                Number(channel),
                row.type === 1
                  ? interactiveChannelList
                  : nonInteractiveChannelList,
              ) +
              ': ' +
              row.languages
            )
          })
          .reduce((accumulator, currentValue) => {
            return `${accumulator}\n${currentValue}`
          }, '')
      }
      return '-'
    })(row),
    channel: ((row) => {
      if (row && row.channel) {
        return row.channel + ': ' + row.languages
      }
      return '-'
    })(row),
    key_account: ((row) => {
      return useValueExchangeLabel(row.key_account, customerTypeList)
    })(row),
    status: parseDemandState(row.status),
    total_tasks: ((row) => {
      if (row && row.total_tasks) {
        return `${row.done_tasks} / ${row.total_tasks}`
      }
      return row.total_tasks
    })(row),
    worktime: ((row) => {
      if (row.work_days) {
        return `${row.work_days}d`
      }
      if (row.work_hours) {
        return `${row.work_hours}h`
      }
      return '-'
    })(row),
    'creation-cell': ((row) => {
      return row.name || '-'
    })(row),
    'estimated-cell': ((row) => {
      return row.estimated_time || '-'
    })(row),
    order_time: parseTime(row.order_time, '{y}-{m}-{d}'),
    biz_scenario: ((row) => {
      return useValueExchangeLabel(row.biz_scenario, bizScenario)
    })(row),
  }
  for (const i in item) {
    item[i] = item[i] !== '' ? item[i] : '-'
  }
  return item
}

export const cookContent = (list, config) => {
  if (list && _.isArray(list) && list.length) {
    return list.map((item) => {
      return _.pick(cookContentItem(item), config)
    })
  }
  return []
}
